import { styled } from "@mui/material/styles"
import { Box, ListItem, AppBar } from "@mui/material"

export const MainLayoutRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  paddingTop: 72,
  height: "100%",
  // Dark ground so the rail colour continues behind the content and the light
  // canvas below reads as a rounded panel floating on it.
  backgroundColor: "#14151C",
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 248,
  },
}))

export const MainBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  zIndex: 1,
  // Rounded floating canvas on the dark ground.
  backgroundColor: "#F6F7F9",
  borderRadius: 20,
  overflow: "auto",
  margin: "0 16px 16px 16px",
  [theme.breakpoints.down("lg")]: {
    margin: "0 8px 8px 8px",
  },
}))

export const NavListItem = styled(ListItem)(({ theme }) => ({
  display: "flex",
  mb: 0.5,
  py: 0,
  px: 2,
}))

export const MainNavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: "transparent",
  boxShadow: "none",
  color: "#12131A",
}))

export const SidebarContainerBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  backgroundColor: "#14151C",
}))

export const MenuContainerBox = styled(Box)(({ theme }) => ({
  height: "100%",
  flexGrow: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  paddingLeft: 12,
  paddingRight: 12,
  paddingBottom: 12,
  overflowY: "hidden",
  overflowX: "hidden",
}))

export const SidebarMenuScrollBox = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  scrollbarWidth: "thin",
  scrollbarColor: "rgba(255,255,255,0.28) transparent",
  paddingRight: 2,
  "&::-webkit-scrollbar": {
    width: 8,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(255,255,255,0.22)",
    borderRadius: 999,
    border: "2px solid #14151C",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "rgba(255,255,255,0.36)",
  },
}))

export const LogoContainerBox = styled(Box)(({ theme }) => ({
  padding: "22px 22px 16px",
  backgroundColor: "transparent",
  display: "flex",
  alignItems: "center",
  "& img": {
    width: 168,
    maxWidth: "100%",
    height: "auto",
    display: "block",
  },
}))
